import { render } from "./welcomeModal.vue?vue&type=template&id=16671909&scoped=true"
import script from "./welcomeModal.vue?vue&type=script&lang=js"
export * from "./welcomeModal.vue?vue&type=script&lang=js"

import "./welcomeModal.vue?vue&type=style&index=0&id=16671909&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16671909"]])

export default __exports__